<template>
    <ion-toolbar>
        <div class="flex justify-around items-center h-16">
            <div
                v-for="link in footerLinks"
                class="icon-link"
            >
                <router-link :to="{ name: link.name }">
                    <ion-icon
                            slot="icon-only"
                            :icon="link.icon"
                            class="h-8 w-8"
                            :class="[getClass(link.name), link.class]"
                        />
                </router-link>
            </div>
        </div>
    </ion-toolbar>
</template>


<script
    setup
    lang="ts"
>
import { RouteNames } from '@/router/routes';
import { IonIcon, IonToolbar } from '@ionic/vue';
import { mapOutline, caretForwardOutline as playCircleOutline, readerOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';

const route = useRouter();

const footerLinks = [
    {
        name: RouteNames.MAP,
        icon: mapOutline,
        class: ""
    },
    {
        name: RouteNames.ACTIVITY,
        icon: playCircleOutline,
        class: "activity-icon"
    },
    {
        name: RouteNames.PROFILE,
        icon: readerOutline,
        class: ""
    }
];

function getClass(routeName: string) {
    return route.currentRoute.value.name === routeName ? 'active-icon' : '';
}

</script>


<style scoped>
.active-icon {
    background: var(--footer-button-active, blue);
}

ion-icon {
    color: white;
    background-color: black;
    border-radius: 50%;
    padding: 0.4rem;
}

ion-icon.activity-icon {
    /** this way it looks more centered */
    padding-left: 0.5rem;
    padding-right: 0.3rem;
}

ion-toolbar {
    --background: var(--header-footer-background, #ECECEC);
}
</style>